/*
 * @Description: 跳转培训中心（三生学院）小程序，并把 H5 登录态带过去用于免登
 */
import Util from 'utils';
import config from 'config/Config';
import { parseCustomLink } from 'biz-micro-services-ui/project/middlePlatform/function/util';

// 培训中心小程序原始ID - 生产
export const SXY_MINI_PROGRAM_ID_PROD = 'gh_b5d04d764715';
// 培训中心小程序原始ID - 测试，对应 APP 端 Api.js 里 UAT3/UAT5 的 TRAINING_CENTER_ID
export const SXY_MINI_PROGRAM_ID_TEST = 'gh_d1a9dfd149ae';
// 唤起小程序的弹窗图片
export const SXY_MINI_PROGRAM_IMG =
  'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/sxy_mini_program_image.png';

/**
 * 走测试小程序的环境
 * 注意：GREEN / BLUE / GRAY 虽然不是 PROD，但接口打的是生产域名，
 * 必须跟生产一样用正式小程序，不能放进这个名单
 */
const TEST_HOSTS = ['DEV', 'TEST', 'TEST2', 'UAT', 'UAT2', 'UAT3', 'UAT4', 'UAT5'];

/**
 * 当前环境是否走生产小程序
 * @returns {boolean}
 */
export const isSxyProdEnv = () => !TEST_HOSTS.includes(config.HOST);

/**
 * 当前环境对应的培训中心小程序原始ID
 * @returns {string}
 */
export const getSxyMiniProgramId = () =>
  isSxyProdEnv() ? SXY_MINI_PROGRAM_ID_PROD : SXY_MINI_PROGRAM_ID_TEST;

/**
 * 给小程序路径拼上 H5 当前登录的 token，小程序侧读 appToken 完成静默登录
 * token 直接取 localStorage，和 request.js 请求头取的是同一份，
 * 避免登录完成后 AppMod.token 还没同步的情况
 * @param {string} path 小程序页面路径
 * @returns {string} 拼接后的路径，未登录时原样返回
 */
export const withAppToken = (path) => {
  const token = Util.getLocalCache(config.localStorageKeys.member_token);
  if (!path || !token) {
    return path;
  }
  // 已经带过 appToken 就不重复拼
  if (path.indexOf('appToken=') > -1) {
    return path;
  }
  const separator = path.indexOf('?') > -1 ? '&' : '?';
  return `${path}${separator}appToken=${encodeURIComponent(token)}`;
};

/**
 * 跳转培训中心小程序（内部用 wx-open-launch-weapp 开放标签，只在微信内有效）
 * @param {string} content 后管配置的 mpsxy:// 链接
 * @returns {boolean} 是否成功唤起弹窗
 */
export default function goSxyMiniProgram(content) {
  const { success, path: routePath } = parseCustomLink(content, 'mpsxy') || {};
  if (!success || !routePath) {
    return false;
  }
  const isProd = isSxyProdEnv();
  window.showMiniProgramModal({
    path: withAppToken(routePath),
    imgUrl: SXY_MINI_PROGRAM_IMG,
    // 测试环境换成测试小程序，和 APP 端 TRAINING_CENTER_ID 的处理保持一致，
    // 否则测试环境的 token 会被送到生产小程序，免登必然失败
    username: getSxyMiniProgramId(),
    // 测试小程序唤起体验版，对应 APP 端 miniProgramType 的 0-正式版 / 2-体验版
    isProd
  });
  return true;
}



// WEBPACK FOOTER //
// ./src/function/goSxyMiniProgram.js